import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';

export class Welcome extends SceneBase {
  constructor() {
    super({ key: KEYS.Welcome, active: false });
  }
  create() {
    super.create();
    this.setBackgroundColour(0x0069b5);
    this.game.hud.setState('WELCOME');

    this.bg = this.add.image(0, 0, 'backgrounds', 'background_welcome').setOrigin(0);
    this.logo = this.add.image(840, 230, 'ui', 'logo').setOrigin(0.5);
  }
}
